import { CalendarModal } from "./calendar.modal";
import { CalendarWeekComponent } from "./calendar-week.component";
import { MonthComponent } from "./month.component";
import { CalendarComponent } from "./calendar.component";
export var CALENDAR_COMPONENTS = [
    CalendarModal,
    CalendarWeekComponent,
    MonthComponent,
    CalendarComponent
];
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ion2-calendar/dist/components/index.js
// module id = 818
// module chunks = 73